<template>
<div class="panel panel-default OTmanualcontrol">
    <button class="OTbuttonPrimary pull-right" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
     Custom Websocket Controls
    </button>
    <div class="clearfix"></div>
    <div class="collapse" id="collapseExample">

        <div class="panel-body">
            <div v-if="connected === true">
                <p>
                    <button v-on:click="onAddECMComponent" class="OTbuttonPrimary">Add ECM Component</button>
                    <button v-on:click="onAddWSMComponent" class="OTbuttonPrimary">Add WSM Component</button>
                    <button v-on:click="onAddPipelineComponent" class="OTbuttonPrimary">Add Pipeline Component</button>
                </p>
                <p>
                    <button v-on:click="onAddECMCluster" class="OTbuttonPrimary">Add ECM Cluster</button>
                    <button v-on:click="onAddWSMCluster" class="OTbuttonPrimary">Add WSM Cluster</button>
                    <button v-on:click="onAddPipelineCluster" class="OTbuttonPrimary">Add Pipeline Cluster</button>
                </p>
                <p>
                    <button v-on:click="onAddGroup" class="OTbuttonPrimary">Add Group</button>
                    <button v-on:click="onAddJob" class="OTbuttonPrimary">Add Job</button>
                    <button v-on:click="killComponent" class="OTbuttonPrimary">Kill a Component</button>
                    <button v-on:click="reviveComponent" class="OTbuttonPrimary">Revive a Component</button>
                </p>
                <p>
                    <button v-on:click="onClear" class="OTbuttonSecondary">Clear All Components</button>
                    <button v-on:click="onReset" class="OTbuttonSecondary">Reset Data</button>
                    <button v-on:click="onSpeedUp" class="OTbuttonSecondary">Speed Up</button>
                    <button v-on:click="onSpeedDown" class="OTbuttonSecondary">Speed Down</button>
                </p>
                <p>
                    <button v-on:click="onLogout" class="OTbuttonSecondary">Logout</button>
                    <button v-on:click="onDisconnect" class="OTbuttonSecondary">Disconnect</button>
                    <button v-on:click="onConnect" class="OTbuttonSecondary">Connect</button>
                </p>
                <div class="alert alert-success" style="margin-top:1rem" role="alert">Connected</div>
            </div>
            <div v-if="connected === false">
                <p>
                    <button v-on:click="onLogout" class="OTbuttonSecondary">Logout</button>
                    <button v-on:click="onDisconnect" class="OTbuttonSecondary">Disconnect</button>
                    <button v-on:click="onConnect" class="OTbuttonSecondary">Connect</button>
                </p>
                <div class="alert alert-warning" role="alert">Waiting for connection...</div>
            </div>
        </div>

     </div>
</div>
</template>

<style lang="scss">

</style>

<script>

import axios from 'axios';

export default {

    computed: {
        connected() {
            return this.$store.state.websocket.isConnected;
        },

        options() {
            return this.$store.state.channels.channelIds;
        },

        subscriptions() {
            return this.$store.state.channels.subscriptions;
        }
    },

    methods: {
        killComponent() {
            this.$socket.sendObj({
                'command': 'kill-a-server'
            });
        },
        reviveComponent() {
            this.$socket.sendObj({
                'command': 'revive-a-server'
            });
        },

        onDisconnect() {
            this.$socket.disconnect();
        },

        onConnect() {
            this.$socket.connect();
        },

        onLogout() {
            axios.post('/otif-dashboard-api/api/v1/authenticate/logout')
                .then((res) => {
                    this.$socket.disconnect();
                    this.$store.dispatch('LOGOUT');
                    location.reload(true);
                })
                .catch((err) => {
                    location.reload(true);
                });
        },

        onLogin() {
            if (this.$store.state.login === false) {
                this.$store.state.login = true;
            } else {
                this.$store.state.login = false;
            }
        },

        onAddJob() {
            this.$socket.sendObj({
                'command': 'add-job'
            });
        },

        onAddGroup() {
            this.$socket.sendObj({
                'command': 'add-group'
            });
        },

        onAddECMComponent() {
            this.$socket.sendObj({
                'command': 'add-component',
                'options': {
                    'type': 'ecm-crawler'
                }
            });
        },

        onAddWSMComponent() {
            this.$socket.sendObj({
                'command': 'add-component',
                'options': {
                    'type': 'wsm-crawler'
                }
            });
        },

        onAddPipelineComponent() {
            this.$socket.sendObj({
                'command': 'add-component',
                'options': {
                    'type': 'pipeline'
                }
            });
        },

        onAddECMCluster() {
            this.$socket.sendObj({
                'command': 'add-cluster',
                'options': {
                    'type': 'ecm-crawler'
                }
            });
        },

        onAddWSMCluster() {
            this.$socket.sendObj({
                'command': 'add-cluster',
                'options': {
                    'type': 'wsm-crawler'
                }
            });
        },

        onAddPipelineCluster() {
            this.$socket.sendObj({
                'command': 'add-cluster',
                'options': {
                    'type': 'pipeline'
                }
            });
        },

        onClear() {
            this.$socket.sendObj({'command':  'clear'});
          //  this.$store.commit('CLEAR_ALL');
        },

        onReset() {
            this.$socket.sendObj({'command': 'reset'});
        },

        onSpeedUp() {
            this.$socket.sendObj({'command': 'speed-up'});
        },

        onSpeedDown() {
            this.$socket.sendObj({'command': 'speed-down'});
        }
    }
}
</script>
